module.exports = __webpack_public_path__ + "img/1_1.a2105193.png";